import { render, staticRenderFns } from "./adBannerV1.vue?vue&type=template&id=960b4a80&scoped=true&"
import script from "./adBannerV1.vue?vue&type=script&lang=js&"
export * from "./adBannerV1.vue?vue&type=script&lang=js&"
import style0 from "./adBannerV1.vue?vue&type=style&index=0&id=960b4a80&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960b4a80",
  null
  
)

export default component.exports